document.addEventListener('DOMContentLoaded', () => {
  const WISHLIST_UPDATE_DELAY = 1000;

  function onSwymLoadCallback(swat) {
    if (!swat) return;

    // Update wishlist count in header
    const updateWishlistCount = (lists) => {
      const wishlistCountEl = document.querySelector('.header__wishlist-count');
      const wishlistCount = lists.reduce((total, list) => total + list.listcontents.length, 0);

      if (wishlistCount !== 0) {
        wishlistCountEl.querySelector('.header__wishlist-count-number').innerText = wishlistCount;
        wishlistCountEl.style.display = 'block';
      } else {
        wishlistCountEl.style.display = 'none';
      }
    };

    // Error callback
    const onError = (error) => {
      console.log('Error while fetching all Lists', error);
    };

    // Fetch wishlist data
    const fetchLists = () => {
      _swat.fetchLists({
        callbackFn: updateWishlistCount,
        errorFn: onError
      });
    };

    // Initial fetch
    fetchLists();

    // Helper to add delayed click listener
    const addDelayedClickListener = (element) => {
      element.addEventListener('click', () => {
        setTimeout(fetchLists, WISHLIST_UPDATE_DELAY);
      });
    };

    // Helper to add click listeners to multiple elements
    const addClickListenersToAll = (selector) => {
      document.querySelectorAll(selector).forEach(addDelayedClickListener);
    };

    // Wait for element to appear in DOM
    const waitForElement = (selector) => {
      return new Promise(resolve => {
        const element = document.querySelector(selector);
        if (element) {
          return resolve(element);
        }

        const observer = new MutationObserver(() => {
          const element = document.querySelector(selector);
          if (element) {
            observer.disconnect();
            resolve(element);
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    };

    // Attach listeners to wishlist collection buttons
    waitForElement('.swym-wishlist-collections-v2').then(() => {
      addClickListenersToAll('.swym-wishlist-collections-v2');
    });

    // Reattach listeners when facet filters change
    document.addEventListener('on:facet-filters:filter-changed', () => {
      setTimeout(() => {
        addClickListenersToAll('.swym-wishlist-collections-v2');
      }, WISHLIST_UPDATE_DELAY);
    });

    // Attach listener to PDP wishlist button
    waitForElement('#swym-atw-pdp-button').then((element) => {
      addDelayedClickListener(element);
    });

    // Attach listeners to delete buttons
    waitForElement('.swym-delete-btn').then(() => {
      addClickListenersToAll('.swym-delete-btn');
    });

    // Attach listener to clear wishlist button
    waitForElement('.swym-clear-wishlist-btn').then((element) => {
      addDelayedClickListener(element);
    });

    // Refresh cart drawer when item added to cart from wishlist
    swat.evtLayer.addEventListener('sw:addedtocart', () => {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));
    });
  }

  // Register callback with Swym
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
});